export const BASE_URL_GRAPH = "https://graph.microsoft.com/v1.0";
export const BASE_URL = "https://func-provisioning-qa-ne-01.azurewebsites.net";
export const SIGNALR_PATH = "https://func-signalr-qa-ne-01.azurewebsites.net/api";
